import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Col, Grid, Row} from 'react-bootstrap';
import BackLink from '../../../common/back-link';
import AccessTokenTable from './access-token-table';
import {getUserAccessTokens} from '../../../../actions/app';
import withPaginatedFilter from '../../../common/withPaginatedFilter';
import TokenFilter from './token-filter';
import PageTitle from '../../../common/page-title';

class UserAccessTokens extends Component {
  render() {
    const {
      tokens, paging, pageNumber, query, handleChange, handleClear, handleSearch, handlePageChange
    } = this.props;

    return (
      <Grid>
        <Row>
          <Col lg={12}>
            <BackLink href="/"/>
            <PageTitle>User access tokens</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <TokenFilter
              onChange={handleChange}
              onClear={handleClear}
              onSearch={handleSearch}
              searchValue={query}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <AccessTokenTable
              currentPage={pageNumber}
              onPageChange={handlePageChange}
              tokens={tokens}
              paging={paging}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  tokens: state.accessTokens.userAccessTokens,
  paging: state.accessTokens.paging
});

export default connect(mapStateToProps)(withPaginatedFilter(UserAccessTokens, getUserAccessTokens));



// WEBPACK FOOTER //
// ./src/components/admin/app/user-access-tokens/user-access-tokens.jsx